import { storeToRefs } from 'pinia';
import { useSystemStore } from '@/stores/system';

type MoneyHelperOptions = {
  showCode?: boolean;
  showSymbol?: boolean;
  decimals?: number;
  trimZeroDecimals?: boolean;
};

export const useMoneyHelper = (cents = 0, options: MoneyHelperOptions = {}) => {
  const systemStore = useSystemStore();
  const { currency } = storeToRefs(systemStore);
  const { showCode = true, showSymbol = true, decimals = 2, trimZeroDecimals = false } = options;
  const code = currency.value?.code ?? '';
  const symbol = currency.value?.symbol ?? '';
  const dollarValue = cents / 100;
  const formattedDollarValue =
    trimZeroDecimals && dollarValue % 1 === 0
      ? dollarValue.toString()
      : dollarValue.toFixed(decimals);
  const formattedPrice = `${showCode ? code : ''}${showSymbol ? symbol : ''}${formattedDollarValue}`;

  return {
    code,
    symbol,
    dollarValue,
    formattedDollarValue,
    formattedPrice,
  };
};

export const formatPrice = (cents: number, options: MoneyHelperOptions = {}): string =>
  useMoneyHelper(cents, options).formattedPrice;
